import React from 'react';
import core from '@fireswan/core';
import {LightningIcon} from 'icons';

import './pickReason.scss';

const getPickReason = pick => {
  try {
    return core.picks.getReason(pick);
  } catch (e) {
    return null;
  }
};

const PickReason = ({pick}) => {
  const pickReason = getPickReason(pick);

  if (!pickReason) {
    return null;
  }

  return (
    <div className="pick-reason">
      <LightningIcon />
      {pickReason}
    </div>
  );
};

PickReason.propTypes = {};

PickReason.defaultProps = {};

export default PickReason;
